import styled, { css } from "styled-components";

export const Wrap = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.text.default};
    ${theme.typography.body1.medium}
  `}

  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      gap: 0.6rem;
    }
  `}
`;

export const LabelStyle = styled.label`
  ${({ theme }) => css`
    ${theme.media.small} {
      ${theme.typography.body3.medium}
    }
  `}
`;

export const BodyStyle = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

export const RequiredStyle = styled.span`
  color: ${({ theme }) => theme.color.text.danger};
`;

export const FooterStyle = styled.div`
  padding-left: 1.4rem;

  ${({ theme }) => theme.typography.body3.regular}
  color: ${({ theme }) => theme.color.text.highEmphasis};
`;
